import React from "react";
import PropTypes from "prop-types";

export function Image(props) {
  return <img {...props} />;
}

Image.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  style:PropTypes.object,
  ariaLabel:PropTypes.string,
  onClick: PropTypes.func,
  className:PropTypes.string,
  draggable: PropTypes.bool,
};

Image.defaultProps = {
  draggable: false,
};
